export const createCertificationsRequests = (client) => ({
    listCertifications: async (params) => {
        const { data, meta, links } = await client.api.get("certifications", {
            params: params,
        });
        return { data, meta, links };
    },
    createCertification: async (payload) => {
        const { data } = await client.api.create("certifications", payload);
        return { data };
    },
});
//# sourceMappingURL=index.js.map